export const environment = {
    production: true,
    domain: 'https://api.prestay.luxe/v4/',
    guestOfferDomain: 'https://prestay.luxe/',
    environmentName: 'prod',
    enableThemeSwitcher: true
};
